import {computed, watch} from "vue";
import {useQrCodeDebugStore} from "@/store";

export function useDebugMode(forceRegenerateQrCode: (forceForDebugMode: boolean) => void) {
  const debugStore = useQrCodeDebugStore();
  const debugContextCode = computed(() => debugStore.contextCode);
  const debugCountryCode = computed(() => debugStore.countryCode);
  const isDebugContextCodeActive = computed(() => debugStore.isDebugContextCodeActive);
  const isDebugCountryCodeActive = computed(() => debugStore.isDebugCountryCodeActive);

  watch([debugContextCode, debugCountryCode], () => forceRegenerateQrCode(true));
  watch([isDebugContextCodeActive, isDebugCountryCodeActive], () => forceRegenerateQrCode(true));
}
